import type { Editor } from '@tiptap/core'

/**
 * Composer context for the TTSlash suggestion extensions, provided by
 * PostContent so the slash command suggestions can be filtered by the target
 * event's kind and tags, and so picking a command can add its `relay:` scoped
 * relays to the RelaySelector.
 *
 * Stored per-editor (extension storage) instead of module-global so multiple
 * mounted composers (main post box, reply boxes) don't clobber each other.
 */

export type TComposerContext = {
  /** kind of the event being composed (1 for notes, 1111 for comments) */
  targetKind: number
  /** tags accumulated on the event being composed */
  targetTags: string[][]
  /** add these relay urls to the relay selector */
  addRelays: (urls: string[]) => void
}

export function getEditorContext(editor: Editor | null | undefined): TComposerContext | null {
  return editor?.storage?.slashCommand?.context ?? null
}

export function setEditorContext(
  editor: Editor | null | undefined,
  value: TComposerContext | null
) {
  if (editor?.storage?.slashCommand) {
    editor.storage.slashCommand.context = value
  }
}
